import React, { useEffect } from "react";
import clsx from "clsx";

import { useSandiTalk } from "../../../../contexts/boardContext";
import { TalkListItem } from "../../../../services/talkServices";

import PostList from "..";
import VerticalRule from "../../../Rule/Vertical";
import CommonSelect, { SelectOption } from "../../../Select";

type Props = {
  postList: TalkListItem[];
  onClickLike: (id: number) => void;
};

export default function PopularPostList({ postList, onClickLike }: Props) {
  const [talk, { updateField }] = useSandiTalk();
  const dateRangeOption: SelectOption[] = [
    { label: "최근 3일", value: "3" },
    { label: "최근 7일", value: "7" },
    { label: "최근 30일", value: "30" },
  ];
  const sortOption: SelectOption[] = [
    { label: "인기글", value: "viewCount.desc" },
    { label: "댓글 TOP", value: "commentCount.desc" },
    { label: "좋아요 TOP", value: "likeCount.desc" },
  ];

  useEffect(() => {
    updateField({
      sort: sortOption[0].value,
      dateRange: dateRangeOption[0].value,
    });

    return () => {
      updateField({
        dateRange: undefined,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="px-5 flex justify-between items-center w-full py-2">
        {/* <SelectTab
          value={talk.sort ?? sortOption[0].value}
          options={sortOption}
          onClick={(selectedOption: SelectOption) => {
            updateField({ sort: selectedOption.value });
          }}
        /> */}
        <div></div>
        <div>
          <CommonSelect
            value={talk.dateRange ?? dateRangeOption[0].value}
            optionList={dateRangeOption}
            onChange={(option) => {
              updateField({ dateRange: option.value });
            }}
            className="border-none w-[110px] text-right !pl-0"
            wrapperClassName="flex justify-end"
            variant="transparent"
            optionOrder="right"
          />
        </div>
      </div>
      <PostList postList={postList} onClickLike={onClickLike} unUseHeader />
    </>
  );
}

export type SelectTabProps = {
  options: SelectOption[];
  onClick?: (option: SelectOption) => void;
  value?: string;
};

export const SelectTab = ({ options, onClick, value }: SelectTabProps) => {
  return (
    <div className="flex gap-2.5 h-[24px]">
      {options.map((option, index) => (
        <React.Fragment key={option.value}>
          {index !== 0 && <VerticalRule />}
          <div
            key={option.value}
            className={clsx([
              "flex items-center justify-center h-full rounded-full font-semibold text-black",
              { "opacity-30": value !== option.value },
            ])}
            onClick={onClick ? () => onClick(option) : undefined}
          >
            {option.label}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
